import { ApiResponse } from '@type/web/api';
import {
  FraudLocalDetailResultType,
  FraudResultType,
  GetFraudProps,
} from '@type/web/fraud';

import { axiosRequest, AxiosDomain } from '@api/config';

const axiosBase = AxiosDomain.edge;

/** 사기 조회 */
export const getFraudLookup = ({
  keyword,
  type,
  osType,
}: GetFraudProps): Promise<ApiResponse<FraudResultType>> => {
  const path = `api/scam/globalSearch`;
  const query = `?keyword=${keyword}&fieldType=${type}&entryType=${osType}`;
  return axiosRequest<FraudResultType>(axiosBase, 'get', path + query);
};

/** 더치트 사기사례 URL 조회 */
export const getFraudLookupWithTheCheat = async ({
  keyword,
  type,
  osType,
}: GetFraudProps): Promise<ApiResponse<string>> => {
  const path = `/v2/fraud/theCheatKeyword`;
  const query = `?keyword=${keyword}&type=${type}&entryType=${osType}`;
  return axiosRequest<string>(axiosBase, 'get', path + query);
};

export const getFraudLocalDetail = async ({
  keyword,
  type,
  osType,
}: GetFraudProps): Promise<ApiResponse<FraudLocalDetailResultType>> => {
  const path = `api/scam/globalSearch/localDetail`;
  const query = `?keyword=${keyword}&fieldType=${type}&entryType=${osType}`;
  return axiosRequest<FraudLocalDetailResultType>(
    axiosBase,
    'get',
    path + query,
  );
};
